import { replicateCartById } from '@ecomm/data-simplisafe-api'
import { voidFn } from '@simplisafe/ewok'
import * as E from 'fp-ts/lib/Either'
import * as O from 'fp-ts/lib/Option'
import { pipe } from 'fp-ts/lib/function'
import { useCallback } from 'react'

import { useSetCart } from '../atoms/useCart'

/**
 * Replicates a cart by cart_id and sets it in the cart atom.
 */
export const useReplicateCart = () => {
  const setCart = useSetCart()

  return useCallback(
    (cartId: string) => {
      const fn = async (id: string) => {
        const cart = await replicateCartById(id)()
        pipe(
          cart,
          E.fold(
            err => setCart(['set_cart_error', err]),
            t => setCart(['update_cart', t])
          )
        )
      }
      pipe(
        O.fromNullable(cartId),
        O.fold(() => voidFn(), fn)
      )
    },
    [setCart]
  )
}
